import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

export default function ScrollToTop() {
  const { pathname } = useLocation()

  useEffect(() => {
    // Scrolls to the top of the page whenever the route changes
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant' // Use 'smooth' for an animated scroll
    })
  }, [pathname]) // Re-run the effect when the pathname changes

  return null // This component doesn't render anything
}
